window.theme = window.theme || {};

/**
 * Slate 
 */
window.Shopify = window.Shopify || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    'shopify:section:load',
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    'shopify:section:unload',
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    'shopify:section:select',
    this._onSelect.bind(this)
  );
  document.addEventListener(
    'shopify:section:deselect',
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    'shopify:block:select',
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    'shopify:block:deselect',
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor, scope) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    if (scope) {
      var instanceExists = this._findInstance(id);
      if (instanceExists) {
        this._removeInstance(id);
      }
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _findInstance: function(id) {
    for (var i = 0; i < this.instances.length; i++) {
      if (this.instances[i].id === id) {
        return this.instances[i];
      }
    }
  },

  _removeInstance: function(id) {
    var i = this.instances.length;
    var instance;

    while(i--) {
      if (this.instances[i].id === id) {
        instance = this.instances[i];
        this.instances.splice(i, 1);
        break;
      }
    }

    return instance;
  },

  _onSectionLoad: function(evt, subSection, subSectionId) {
    if (theme && theme.initGlobals) {
      theme.initGlobals();
    }

    var container = subSection ? subSection : evt.target;
    var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');

    if (!section) {
      return;
    }

    this._createInstance(section);

    var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

    // Check if we have subsections to load
    var haveSubSections = container.querySelectorAll('[data-subsection]');
    if (haveSubSections.length) {
      this.loadSubSections(container);
    }

    // Run JS only in case of the section being selected in the editor
    // before merchant clicks "Add"
    if (instance && typeof instance.onLoad === 'function') {
      instance.onLoad(evt);
    }

    // Force editor to trigger scroll event when loading a section
    setTimeout(function() {
      window.dispatchEvent(new Event('scroll'));
    }, 200);
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter(function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  loadSubSections: function(scope) {
    var sections = scope
    ? scope.querySelectorAll('[data-subsection]')
    : document.querySelectorAll('[data-subsection]');

    sections.forEach(el => {
      this._onSectionLoad(null, el, el.dataset.sectionId);
    });
  },

  _onSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onSelect === 'function'
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onDeselect === 'function'
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockSelect === 'function'
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockDeselect === 'function'
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor, scope) {
    this.constructors[type] = constructor;

    var sections = document.querySelectorAll('[data-section-type="' + type + '"]');

    if (scope) {
      sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
    }

    sections.forEach(
      function(container) {
        this._createInstance(container, constructor, scope);
      }.bind(this)
    );
  },

  reinit: function(section) {
    for (var i = 0; i < this.instances.length; i++) {
      var instance = this.instances[i];
      if (instance['type'] === section) {
        if (typeof instance.forceReload === 'function') {
          instance.forceReload();
        }
      }
    }
  }
});

theme.config = {
  bpSmall: false,
  bpSmallValue: 589,
  hasSessionStorage: true,
  mediaQuerySmall: 'screen and (max-width: 589px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};
theme.recentlyViewedIds = [];

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('%c ' + window.BOOMR.themeName + ' theme (' + window.BOOMR.themeVersion + ')' + '%c Learn more at https://stickyt.com/'+ window.BOOMR.themeName + '.html', 'background: red; color: white; display: block; font-size: 15px', 'background: transparent; color: red; display: block;  font-size: 12px');
}

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 2.2;

(function(){
  'use strict';
  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces )
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };

  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  
  theme.Helpers = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      if (!el) {
        return
      }
      
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }

      el.classList.add('is-transitioning');
      this.drawerPath = el.offsetWidth

      if (typeof callback === 'function') {
        callback();
      }
    },
  
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };
  
  
  window.slate = window.slate || {};
  /**
   * A11y Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help make your theme more accessible
   * to users with visual impairments.
   *
   *
   * @namespace a11y
   */
  
  slate.a11y = {
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      /*
       * Get every possible visible focusable element
       */
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);
  
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
  
      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }
  
      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();
 
	  options.elementToFocus.scrollIntoView()
  
      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function() {
        document.documentElement.off(eventsName.keydown);
      });
  
      document.documentElement.on(eventsName.focusin, function(evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
        document.documentElement.on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
  
      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.container) {
        options.container.removeAttribute('tabindex');
      }
  
      document.documentElement.off(eventName);
    },
  
    lockMobileScrolling: function(namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function() {
        return true;
      });
    },
  
    unlockMobileScrolling: function(namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };
  
  /*
   * Add class when tab key starts being used to show outlines
   */
  document.documentElement.on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   * Alternatives
   * - Accounting.js - http://openexchangerates.github.io/accounting.js/
   *
   */
  
  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      
      if (!format) {
        format = theme.settings.moneyFormat;
      }
      
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = theme.Helpers.defaultTo(thousands, ',');
        decimal = theme.Helpers.defaultTo(decimal, '.');
        precision = theme.Helpers.defaultTo(precision, 2);
        
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes('.')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();

  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
  
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    function buildImagePath(string, widths) {
  
      if (string == null) return [];
  
      if (widths) {
        const imageUrls = [];
  
        widths.forEach(width => {
          let url = `${string}?width=${width}`;
          if (width === widths[widths.length - 1]) {
            url += ` ${width}w`
          } else {
            url += ` ${width}w,`
          }
          imageUrls.push(url);
        })
        return imageUrls;
      } else {
        return [string];
      }
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      buildImagePath: buildImagePath
    };
  })();
  
  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function(options) {
    var threshold = options.threshold ? options.threshold : 0;
  
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, {rootMargin: '0px 0px '+ threshold +'px 0px'});
  
    observer.observe(options.element);
  };
  
  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  
  /**
   * iFrames
   * -----------------------------------------------------------------------------
   * Wrap videos in div to force responsive layout.
   *
   * @namespace iframes
   */

    slate.rte = function() {
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.Helpers.wrap(table, wrapWith);
    });
  
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });
  
    function wrapVideo(iframe) {
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.Helpers.wrap(iframe, wrapWith);
    }
  
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }
  
  window.vimeoApiReady = function() {
    theme.config.vimeoLoading = true;

    checkIfVimeoIsReady()
      .then(function() {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        document.dispatchEvent(new CustomEvent('vimeoReady'));
      });
  }
  
  function checkIfVimeoIsReady() {
    var wait;
    var timeout;
  
    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function() {
        if (!Vimeo) {
          return;
        }
  
        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);
  
      timeout = setTimeout(function() {
        clearInterval(wait);
        reject();
      }, 4000);
    });
  
    return deferred;
  }
  
  (function() {
    var originalResizeMethod = Flickity.prototype.resize;
    var lastWidth = window.innerWidth;
  
    Flickity.prototype.resize = function() {
      if (window.innerWidth === lastWidth) {
        return;
      }
  
      lastWidth = window.innerWidth;
      originalResizeMethod.apply(this, arguments);
    }
  })();
  
  /*
   * Flickity scrolling
   */
  (function() {
    var e = !1;
    var t;
  
    document.body.addEventListener('touchstart', function(i) {
      if (!i.target.closest('.flickity-slider')) {
        return e = !1;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      }
    })
  
    document.body.addEventListener('touchmove', function(i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
      }
    }, { passive: !1 })
  })();

  
  
  var global_collapsibleTarget = '';
  var global_collapsibleContainer = '';
  theme.collapsibles = (function() {
    var namespace = '.collapsible';
    var isTransitioning = false;
    var saveTrigger = false;
    
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height'
    };
    
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner'
    };
  
    function init(scope) {
      var el = scope ? scope : document;

      if (window.location.pathname.indexOf('/blogs/') !== -1) {
        saveTrigger = true
      }
      el.querySelectorAll(selectors.trigger).forEach(element => {
        trigger(element)
      });
    }
    
    function trigger(trigger) {
      var state = trigger.classList.contains(classes.open);
      trigger.setAttribute('data-expanded', state);

      trigger.off('click' + namespace);
      trigger.on('click' + namespace, toggle);

      var selectedId = Cookies.get("collapsible-trigger")
      if (selectedId) {
        if (saveTrigger == true) {
          if (selectedId == trigger.dataset.controls) {
            toggle(null, selectedId)
          }         
        } else {
          Cookies.set('collapsible-trigger', null);
        }        
      }
    }
  
    function toggle(evt, id) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el;
      if (evt) {
         el = evt.currentTarget;
      } else if (id){
        el = document.querySelector('button[data-controls="' + id + '"]')
      } else {
        return
      }
     
      var isOpen = el.classList.contains(classes.open);
      var moduleId = el.getAttribute('data-controls');
      var container = document.getElementById(moduleId);

      if (el.getAttribute('data-controls') == 'Pickup-availability' && el.parentNode) {
        container = el.querySelector("#"+moduleId)
        var availabilityBtn = el.parentNode.querySelector("[data-pickup-availability-button]")//document.getElementById("PickupAvailabilityButton");

        if (availabilityBtn.classList.contains(classes.open)) {
          availabilityBtn.classList.remove(classes.open);       
        } else {
          availabilityBtn.classList.add(classes.open);
        }
      }

      if (el.dataset.controls != null && el.dataset.controls.includes('CollectionSidebar')) {
        global_collapsibleTarget = ''
        global_collapsibleContainer = ''
      }
      
      if (!moduleId) {
        moduleId = el.dataset.controls;
        if (!moduleId) {
          return;
        }
      }

      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
        
        if (!container) {
          isTransitioning = false;
          return;
        }
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('data-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
        Cookies.set('collapsible-trigger', null);
      } else {
        el.classList.add(classes.open);
        if (global_collapsibleContainer != '' && global_collapsibleTarget != el) {
          global_collapsibleTarget.setAttribute('data-expanded', !isOpen);
          global_collapsibleTarget.classList.remove(classes.open);
          setTransitionHeight(global_collapsibleContainer, 0, true, false);
        }
        global_collapsibleTarget = el
        global_collapsibleContainer = container
        Cookies.set('collapsible-trigger', el.dataset.controls);
      }
      setTransitionHeight(container, height, isOpen, isAutoHeight);
  
      if (parentCollapsibleEl) {
        var totalHeight = isOpen ? parentCollapsibleEl.offsetHeight - childHeight : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
  
      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function() {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.Helpers.prepareTransition(container, function() {
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init,
      trigger: trigger
    };
  })();
  

  theme.Disclosure = (function() {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
  
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
  
    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }
  
    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },
  
      _setupListeners: function() {
        var footer_locale = document.getElementById("FooterLocale");
      }
    });
  
    return Disclosure;
  })();
    
  theme.Slideshow = (function() {
    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause',
    };
    
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'slideshow__pause--is-paused',
      isActive: 'is-active'
    };
  
    var productSelectors = {
      thumb: '.product-single__thumbnail-item:not(.hide)',
      links: '.product-single__thumbnail-item:not(.hide) a',
      arrow: '.product-single__thumbnail-arrow'
    };
  
    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      childNav: null,
      childNavScroller: null,
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true,
      arrowShape: 'M 25 50 L 70 93 L 67 90 L 25 50 L 65 10 L 68 7 Z'
    };
  
    function slideshow(el, args, setGallerySize) {
      if (el.id.includes('ProductPhotos-')) {
        defaults.setGallerySize = false;
      } else {
        defaults.setGallerySize = true;
      }

      this.el = el;
      this.args = Object.assign({}, defaults, args);
      this.slideIndex = 0;
      
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        
        if (this.childNavEls.length < 2) {
          this.args.pageDots = false
        }
        
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      this.slideshow = new Flickity(el, this.args);
      
      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        if (wrapper != null) {
          this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
          if (this.pauseBtn) {
            this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
          }
        }
      }

      var windowWidth = window.innerWidth;
      window.on('resize', theme.Helpers.debounce(300, function() {
        if (window.innerWidth != windowWidth) {windowWidth = window.innerWidth}else{return}
        this.resize(); 
      }.bind(this)));
      this.embeddedResize(0)

      if (this.slideshow.element.querySelector(".collapsible-trigger-btn") != null) {
        this.slideshow.element.querySelectorAll(".collapsible-trigger-btn").forEach(btn => {
          btn.addEventListener("click", function(btn){ 
            this.resize(); 
            this.slideshow.resize();
          }.bind(this));
        });
      }
    }
    
    function fadeIn(el,i) {
      var go = function(i) {
          setTimeout( function(){ seto(el,i); } , i * 1000);
      };
      for ( i = 0 ; i<=1 ; i = i + 0.01) go(i);
    }

    function seto(el,i) {
        el.style.opacity = i;
    }
  
    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function(el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit();
          }
        }  
      },
  
      slideChange: function(index) {
        this.slideIndex = index
        this.embeddedResize(this.slideIndex)

        if (this.el.parentElement.getAttribute("data-section-type") == "splittedtexts") {
          var section_id = this.el.id.replace(/\--/,'&').split('&')[1];
          
          if (document.querySelector('#SplittedImages--' + section_id) != null) {

          
            var slideProduct = document.querySelector('#ProductSection-' + section_id + index)
            if (slideProduct != null && slideProduct.dataset.generated == "false") {
              slideProduct.dataset.generated = "true"
              this.Product = new theme.Product(slideProduct)
            }

            this.slideshow.resize();
            
            var image_section = document.querySelector('#SplittedImages--' + section_id).querySelectorAll('.splittedimages-slide--'+section_id);

            var product_slide_id = document.querySelector('.splittedtexts-slide-'+ index + '--' + section_id).classList[0].replace('product-slide--', '');
            var productLinkers = document.querySelectorAll('.product-link--button')

            if (productLinkers != null) {
              productLinkers.forEach((el) => {
                el.classList.remove('is-active')
              });
            }

            if (product_slide_id != 'images-slide') {
              if (document.querySelector('.product-linker-' + product_slide_id) != null) {
                document.querySelector('.product-linker-' + product_slide_id).classList.add("is-active");
              }
            }

            if (image_section.length > 1 && document.querySelector("#splitted-image-"+index+"--"+section_id) != null) {
              image_section.forEach((el) => {
                el.style.display = 'none'
              });
              document.querySelector("#splitted-image-"+index+"--"+section_id).style.display = 'block'
              fadeIn(document.querySelector("#splitted-image-"+index+"--"+section_id),0);
            }
          }
        }

        if (this.args.fade) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function() {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }
  
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }
  
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }
  
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      
      afterChange: function(index) {
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }
  
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      
      destroy: function() {
        this.slideshow.destroy();
      },
      /*_togglePause: function() {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },*/

      reposition: function() {
        this.slideshow.reposition();
      },
      _togglePause: function() {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      
      resize: function() {
        this.slideshow.resize();
        this.embeddedResize(this.slideIndex)
      },
      
      embeddedResize: function(index) {
        if (this.el.id.includes('ProductPhotos-')) {
          var flickityContainer = document.querySelector('#' + this.el.id + " .flickity-viewport")
          var sectionId = this.el.id.replace('ProductPhotos-','')

          var productSlider = flickityContainer.querySelectorAll('.product-single_main-slide')
          var selectedSlider = flickityContainer.querySelector('.is-selected')

          var aspectRatio = 0;
          if (selectedSlider.querySelector('img')) {
            aspectRatio = selectedSlider.querySelector('img').dataset.aspectratio
          }else if (selectedSlider.querySelector('.shopify-model-viewer-ui')) {
            aspectRatio = selectedSlider.querySelector('.shopify-model-viewer-ui').dataset.aspectratio
          }

          if (productSlider[index] && productSlider[index].offsetHeight != 0) {
            flickityContainer.style.height = productSlider[index].offsetHeight + 'px'
          } else {
            flickityContainer.style.height = 200 / aspectRatio + 'px'
          }

          var sliderContainer = this.el.closest(".flickity-viewport")
          if (sliderContainer) {
            var selectedSlider = sliderContainer.querySelector('.is-selected')
            if (selectedSlider && selectedSlider.querySelector('.embedded-product-single__meta')) {
              var productMetaHeight = selectedSlider.querySelector('.embedded-product-single__meta').offsetHeight
              sliderContainer.style.height = selectedSlider.offsetHeight + 'px'
            }
          }

          var detailsDivider = document.querySelector('#DetailsDivider-' + sectionId)
          if (detailsDivider) {
            var product_image = document.querySelector('#ProductImages-' + sectionId)
            if (product_image) {
            document.documentElement.style.setProperty('--sticky_divider-padding', product_image.offsetHeight*1.15 + 'px');
            document.querySelector(".blurred-container").style.height = product_image.offsetHeight + 'px'
            }            
          }
        } else if (this.el.id.includes('SplittedTexts-')) {
          var flickityContainer = document.querySelector('#' + this.el.id + " .flickity-viewport")
          var sectionId = this.el.id.replace('SplittedTexts-','')
          if (flickityContainer) {
            var imageSlider = flickityContainer.querySelector('.images-slide.is-selected')
            var productSlider = flickityContainer.querySelectorAll('.product-single_main-slide')
  
            var selectedSlider = flickityContainer.querySelector('.images-slide.is-selected')
  
            if (selectedSlider) {
              var productMetaHeight = 0
              if(selectedSlider.querySelector('.embedded-product-single__meta')) {
                productMetaHeight = selectedSlider.querySelector('.embedded-product-single__meta').offsetHeight
              }
              flickityContainer.style.height = selectedSlider.offsetHeight + 'px'
            }
          }         
        }
      },

      play: function() {
        this.slideshow.playPlayer();
      },
      pause: function() {
        this.slideshow.pausePlayer();
      },
      goToSlide: function(i) {      
        this.slideshow.select(i); 
      },
      setDraggable: function(enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },
  
      initChildNav: function() {
        this.childNavLinks.forEach(a => {
          a.classList.remove(classes.isActive);
        });
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');

        this.childNavLinks.forEach((link, i) => {
          link.setAttribute('data-index', i);
  
          link.addEventListener('click', function(evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function(evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });

        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });;
        }
      },
  
      getChildIndex: function(target) {
        return parseInt(target.dataset.index);
      },
  
      childNavGoTo: function(index) {
        this.childNavLinks.forEach(a => {
          a.classList.remove(classes.isActive);
        });
  
        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);
  
        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },
  
      arrowClick: function(evt) {
        if (evt.currentTarget.classList.contains('product-single__thumbnail-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });
  
    return slideshow;
  })();
  
  theme.parallaxSections = {};
  
  theme.Parallax = (function() {
    var speed = 0.85;
    var reset = false;
  
    function parallax(container, args) {
      this.isInit = false;
      this.isVisible = false;
      this.container = container;
      this.image = container.querySelector('.parallax-image');
      this.namespace = args.namespace;
      this.desktopOnly = args.desktopOnly;
  
      if (!this.container || !this.image) {
        return;
      }
  
      if (this.desktopOnly) {
        document.addEventListener('matchSmall', function() {
          this.destroy();
        }.bind(this));
  
        document.addEventListener('unmatchSmall', function() {
          this.init(true);
        }.bind(this));
      }
  
      this.init(this.desktopOnly);
    }
  
    parallax.prototype = Object.assign({}, parallax.prototype, {
      init: function(desktopOnly) {
        if (this.isInit) {
          this.destroy();
        }
  
        this.isInit = true;
  
        if (desktopOnly && theme.config.bpSmall) {
          return;
        }
  
        this.setSizes();
        this.scrollHandler();
  
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible) {
              window.on('scroll' + this.namespace, this.onScroll.bind(this));
            } else {
              window.off('scroll' + this.namespace);
            }
          });
        }, {rootMargin: '200px 0px 200px 0px'});
  
        observer.observe(this.container);
  
        //window.on('resize' + this.namespace, theme.Helpers.debounce(250, this.setSizes.bind(this)));

        var windowWidth = window.innerWidth;
        window.on('resize'  + this.namespace, theme.Helpers.debounce(250, function() {
          if (window.innerWidth != windowWidth) {windowWidth = window.innerWidth}else{return}
           this.setSizes.bind(this)
        }.bind(this)));
  
        document.addEventListener('shopify:section:reorder', theme.Helpers.debounce(250, this.onReorder.bind(this)));
      },
  
      onScroll: function() {
        if (!this.isVisible) {
          return;
        }

        if (window.SPR && !reset) {
          this.setSizes();
          reset = true;
        }
  
        requestAnimationFrame(this.scrollHandler.bind(this));
      },
  
      scrollHandler: function() {
        var shiftDistance = (window.scrollY - this.elTop) * speed;
        this.image.style.transform = 'translate3d(0, ' + shiftDistance + 'px, 0)';
      },
  
      setSizes: function() {
        var rect = this.container.getBoundingClientRect();
        this.elTop = rect.top + window.scrollY;
      },
  
      onReorder: function() {
        this.setSizes();
        this.onScroll();
      },
  
      destroy: function() {
        this.image.style.transform = 'none';
        window.off('scroll' + this.namespace);
        window.off('resize' + this.namespace);
      }
    });
  
    return parallax;
  })();

  theme.QtySelector = (function() {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus',
      remove: '.js-qty__adjust--empty'
    };
  
    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.remove = el.querySelector(selectors.remove);
      this.minValue = this.input.getAttribute('min') || 1;

      this.sectionId = options.sectionId

      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };
  
      this.options = Object.assign({}, defaults, options);
  
      this.init();
    }
  
    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.plus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty + 1, false);
        }.bind(this));
  
        this.minus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty - 1, false);
        }.bind(this));
        
        if (this.remove) {
          this.remove.addEventListener('click', function() {
            this._change(0, true);
          }.bind(this));
        }
  
        this.input.addEventListener('change', function(evt) {
          this._change(this._getQty(), false);
        }.bind(this));
      },
  
      _getQty: function() {
        var qty = this.input.value;
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
        } else {
          qty = 1;
        }
        return parseInt(qty);
      },
  
      _change: function(qty, isRemove) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        if (!isRemove){
          this.input.value = qty;
        }

        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper]
          }));
        }

        if (document.querySelector("#CustomVariantQuantity-" + this.sectionId)) {
          document.querySelector("#CustomVariantQuantity-" + this.sectionId).value = qty
        }
        
      }
    });
  
    return QtySelector;
  })();

  theme.articleImages = function() {
    var wrappers = document.querySelectorAll('.rte--indented-images');
  
    if (!wrappers.length) {
      return;
    }
  
    wrappers.forEach(wrapper => {
      wrapper.querySelectorAll('img').forEach(image => {
        var attr = image.getAttribute('style');
        if (!attr || attr == 'float: none;') {
          if (image.width < wrapper.offsetWidth) {
            image.classList.add('rte__no-indent');
          }
        }
      });
    });
  };
  
  
  
  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      if (!formState) {
        return;
      }
  
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
    
    function setAddressForm(evt) {
      var isHide = evt.classList.contains('hide')
      if(isHide) {
        document.querySelector('.section-header__title').innerHTML = theme.strings.addressTitle
      } else {
        document.querySelector('.section-header__title').innerHTML = theme.strings.addressNew        
      } 

      document.querySelectorAll('.js-address-grid').forEach(el => {
        if(isHide) {
          el.classList.remove('hide')
        } else {
          el.classList.add('hide')
        }
      })
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);

      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          document.getElementById('AddressNewForm').classList.toggle('hide');
          setAddressForm(document.getElementById('AddressNewForm'))
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
          document.querySelector('.section-header__title').innerHTML = theme.strings.addressEdit 
          
          setAddressForm(document.getElementById('EditAddress_' + formId))
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };

  window.onpageshow = function(evt) {
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });  
    }

    document.querySelectorAll(".image-grid-item--loader").forEach((el) => {
      el.classList.remove('loading', 'loading--delayed');
      el.classList.add('loaded');
    });
  };
  
  theme.pageTransitions = function() {
    if (document.body.dataset.transitions === 'true') {
      if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
        document.querySelectorAll('a').forEach(a => {
          window.setTimeout(function() {
            document.body.classList.remove('unloading');
          }, 1200);
        });
      }
  
      document.querySelectorAll('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[download]').forEach(el => {
        el.classList.add('js-no-transition');
      });
  
      document.querySelectorAll('a:not(.js-no-transition)').forEach(el => {
        el.addEventListener('click', function(evt) {
          if (evt.metaKey) return true;
          evt.preventDefault();
          document.body.classList.add('unloading');
          var src = el.getAttribute('href');
          window.setTimeout(function() {
            location.href = src;
          }, 50);
        });
      });
  
      document.querySelectorAll('a.mobile-nav__link').forEach(el => {
        el.addEventListener('click', function() {
          theme.MenuDrawer.close();
        })
      });
    }
  };

  theme.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;
  
      if (!this.slideshow) { return }

      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');
  
        this.slideshow.querySelectorAll(".image-grid-item--loader").forEach((el) => {
          el.classList.remove('loading', 'loading--delayed');
          el.classList.add('loaded');
        });

        slides.forEach((el) => {
          el.classList.remove('loading', 'loading--delayed');
          el.classList.add('loaded');
        });
        //theme.loadImageSection(this.slideshow);
  
        if (slides.length > 1) {
          var defaults = {
            prevNextButtons: false,
            pageDots: this.slideshow.hasAttribute('data-slider-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            pauseAutoPlayOnHover: false,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false
          };
  
          this.flickity = new theme.Slideshow(this.slideshow, defaults);

          this.siteNavBtns = this.container.querySelectorAll(".site-nav__dropdown-link")
          
          if (this.flickity.el.querySelector(".dot")) {
            this.flickity.el.querySelectorAll(".dot").forEach((el, index) => {  
              var node = this.siteNavBtns[index]//slides[index].querySelector('.h1.hero__title')
              if (node) {
                var htmlContent = node.innerHTML
                var textContent = node.textContent || node.innerText;  
                var html = document.createElement('div');
                html.innerHTML = `<button class="btn btn--inverse small--hide">${textContent}</button>`; 
                el.appendChild(html.firstElementChild);
  
                el.querySelector(".btn").addEventListener("click", function(){ 
                  this.flickity.goToSlide(index)
                  this.flickity.pause()
                }.bind(this));

                if (this.siteNavBtns.length > 0) {
                  this.siteNavBtns[index].addEventListener("click", function(){ 
                    if (this.flickity.slideIndex == index && this.siteNavBtns[index].dataset.url != "") {
                      window.location.href = this.siteNavBtns[index].dataset.url
                    } else {
                      this.flickity.goToSlide(index)
                      this.flickity.pause()
                    }  
                  }.bind(this));
                }
              }
            });
          }          
        } else {
          slides[0].classList.add('is-selected');
        }
  
        if (this.container.hasAttribute('data-parallax')) {
          this.container.querySelectorAll(selectors.parallaxContainer).forEach(function(el, i) {
            new theme.Parallax(el, {
              namespace: this.namespace + '-parallax-' + i
            });
          }.bind(this));
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          this.initialIndex = index;
          setTimeout(function() {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });
  
    return SlideshowSection;
  })();

  theme.BackgroundImage = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function backgroundImage(container) {
      this.container = container;

      this.container.querySelectorAll(".image-grid-item--loader").forEach((el) => {
        el.classList.remove('loading', 'loading--delayed');
        el.classList.add('loaded');
      });

      if (!container) {
        return;
      }
  
      var sectionId = container.getAttribute('data-section-id');
      this.namespace = '.' + sectionId;
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this)
      });
    }
  
    backgroundImage.prototype = Object.assign({}, backgroundImage.prototype, {
      init: function() {
        if (this.container.dataset && this.container.dataset.parallax) {
          var parallaxContainer = this.container.querySelector(selectors.parallaxContainer);
          var args = {
            namespace: this.namespace,
            desktopOnly: true
          };
  
          theme.parallaxSections[this.namespace] = new theme.Parallax(parallaxContainer, args);
        }
      },
  
      onUnload: function(evt) {
        if (!this.container) { return }
        if (theme.parallaxSections[this.namespace] && typeof theme.parallaxSections[this.namespace].destroy === 'function') {
          theme.parallaxSections[this.namespace].destroy();
        }
        delete theme.parallaxSections[this.namespace];
      }
    });
  
    return backgroundImage;
  })();
  
  theme.TabSwitcher = (function() {
    var selectors = {
      trigger: '.tab-switcher__trigger',
      collection: '.tab-switcher__collection',
      slider: '.tab-switcher__slider',
      wrapper: '.collection-slider-wrapper',
      
    };
  
    var defaults = {
      adaptiveHeight: true,
      autoPlay: false,
      cellAlign: 'left',
      fade: false,
      prevNextButtons: true,
      setGallerySize: true,
      wrapAround: false
    };
  
    function TabSwitcher(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.slideshows = container.querySelectorAll(selectors.slider);
      this.namespace = '.switcher-' + this.sectionId;
      this.showArrows = this.container.getAttribute('data-show-arrows')
      this.flickity = {};
      this.activeIndex = 0;

      this.container.querySelectorAll(".image-grid-item--loader").forEach((el) => {
        el.classList.remove('loading', 'loading--delayed');
        el.classList.add('loaded');
      });

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 300
      });
    }
  
    TabSwitcher.prototype = Object.assign({}, TabSwitcher.prototype, {
      init: function() {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click', this.switch.bind(this));
        });

        if (this.container.getAttribute('data-style') == 'slider') {
          var width = 400;
          if (this.container.querySelectorAll('.grid-product')[1] != null) {
            width = this.container.querySelectorAll('.grid-product')[1].offsetWidth
          }

          this.container.querySelectorAll(selectors.collection).forEach(collection => {
            var slider = collection.querySelector(selectors.slider)

            if(slider) {
              new SimpleBar(slider, { autoHide: false });
            }
            

            if (this.showArrows == 'true') {
              collection.querySelector('.flickity-next').addEventListener('click', function (e) {
                var contentWrapper = slider.querySelector('.simplebar-content-wrapper')
                var left = contentWrapper.pageXOffset || contentWrapper.scrollLeft;
                left = left + width

                contentWrapper.scrollTo({
                  left: left,
                  behavior: 'smooth',
                });
              }.bind(this))

              collection.querySelector('.flickity-previous').addEventListener('click', function (e) {
                var contentWrapper = slider.querySelector('.simplebar-content-wrapper')
                var right = contentWrapper.pageXOffset || contentWrapper.scrollLeft;
                right = right - width

                contentWrapper.scrollTo({
                  left: right,
                  behavior: 'smooth',
                });
              }.bind(this))
            }
          });
        }        
      },
  
      switch: function(evt) {
        evt.preventDefault();
  
        var containerId = evt.currentTarget.getAttribute('data-controls');
        var newContainer = document.getElementById(containerId);
        this.activeIndex = parseInt(newContainer.dataset.index);
  
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.classList.remove('is-active');
        });
  
        evt.currentTarget.classList.add('is-active');
  
        // Hide collections, show new one
        this.container.querySelectorAll(selectors.collection).forEach(collection => {
          collection.classList.add('hide');
        });
  
        newContainer.classList.remove('hide');
  
  
        if (this.flickity[this.activeIndex] && typeof this.flickity[this.activeIndex].resize === 'function') {
          this.flickity[this.activeIndex].resize();
        }
      },
  
      destroy: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onUnload: function() {
        this.destroy();
      }
  
    });
  
    return TabSwitcher;
  })();
  
  theme.isStorageSupported = function(type) {
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };
  
  theme.Splittedtexts = (function() {
    var defaults = {
      adaptiveHeight: true,
      pageDots: true,
      autoPlay: false,
      prevNextButtons: true,
      pauseAutoPlayOnHover: true,
      watchCSS: false
    };
    
    function Text(container) {
      this.container = container;
      this.contentSize = parseInt(container.getAttribute('data-content-size'));
      this.section_id = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#SplittedTexts--' + this.section_id);
      this.namespace = '.splittedtext-' + this.section_id;

      this.container.querySelectorAll(".image-grid-item--loader").forEach((el) => {
        el.classList.remove('loading', 'loading--delayed');
        el.classList.add('loaded');
      });
  
      if (!this.slideshow) { return }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
    
    Text.prototype = Object.assign({}, Text.prototype, {
      init: function() {
        defaults.wrapAround = true;
        
        if (this.slideshow.dataset.watchcss == 'true') {
          defaults['watchCSS'] = true;
        } else {
          defaults['watchCSS'] = false;
        }

        if (this.slideshow.dataset.autoplay == 'true') {
          defaults['autoPlay'] = true;
        } else {
          defaults['autoPlay'] = false;
        }

        if (this.slideshow.dataset.count <= 1) {
          defaults['pageDots'] = false;
        } else {
          defaults['pageDots'] = true;
        }

        if (this.slideshow.dataset.buttons == 'true') {
          defaults['prevNextButtons'] = true;
        } else {
          defaults['prevNextButtons'] = false;
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults); 

        var firstSlideProduct = document.querySelector('#ProductSection-' + this.section_id + 0)
        if (firstSlideProduct && firstSlideProduct.dataset.generated == "false") {
          firstSlideProduct.dataset.generated = "true"
          this.Product = new theme.Product(firstSlideProduct)         
        }

        var image_section = document.querySelector('#SplittedImages--' + this.section_id).querySelectorAll('.splittedimages-slide--'+this.section_id)

        if (image_section.length > 0 && this.flickity.currentSlide != undefined) {
          var first_slide = this.flickity.currentSlide.classList[0].replace('product-slide--', '')
          
          image_section.forEach((el, index) => {
            var trigger_slideshow = this.flickity
            
            var selectorButton = document.querySelectorAll('[id^="SlideSelector-' + index + '--' + this.section_id + '"]');

            if (selectorButton.length > 0) {
              selectorButton.forEach((button) => {
                if(button.getAttribute("data-product-selector") == first_slide) {
                  button.classList.add('is-active')
                }
                button.addEventListener( 'click', function( event ) {
                  var slide_id = event.target.getAttribute("data-product-selector")
                  var slide = document.querySelector('.product-slide--'+slide_id)
                  if (slide != null) {
                    trigger_slideshow.goToSlide(parseInt(slide.getAttribute('data-index')));
                  }
                })
              });
            }
          });
        }

        if (image_section.length > 0 && this.slideshow.dataset.watchcss == 'true') {
          var listButtons = this.slideshow.querySelectorAll(".list-item--btn")

          this.selectedIndex = 0
          listButtons.forEach((btn, index) => {
            btn.addEventListener("click", function(){ 
              this.selectedIndex = parseInt(btn.dataset.index) - 1
              listButtons.forEach((el) => {
                el.classList.remove("is-selected")
              });
              btn.classList.add("is-selected")
              
              image_section.forEach((el) => {
                el.style.display = 'none'
              });
              document.querySelector("#splitted-image-"+index+"--"+this.section_id).style.display = 'block';
            }.bind(this));
          })

          /*if (this.slideshow.dataset.autoplay == 'true') {
            setInterval(function(){ 
              this.selectedIndex = this.selectedIndex < image_section.length - 1 ? this.selectedIndex + 1 : 0
              
              var previousIndex = this.selectedIndex - 1 < 0 ? image_section.length - 1 : this.selectedIndex - 1
              //document.querySelector("#splitted-image-"+previousIndex+"--"+this.section_id).style.display = 'none';  
              //document.querySelector("#splitted-image-"+this.selectedIndex+"--"+this.section_id).style.display = 'block';

              this.slideshow.querySelector(".list-item--btn--" + previousIndex).classList.remove("is-selected")
              this.slideshow.querySelector(".list-item--btn--" + this.selectedIndex).classList.add("is-selected")
            }.bind(this), 2000);
          }*/
        }
      },
      
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.splittedtexts-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
      
      onListSelect: function() {
        
      }
      
    });
  
    return Text
  })();

  theme.Promotion = (function() {
    function Promotion(container) {
      this.container = container;
      this.init()
    }
    
    Promotion.prototype = Object.assign({}, Promotion.prototype, {
      init: function() {
        var sectionId = this.container.getAttribute('data-section-id')
        var enableSlideshow = this.container.dataset.slideshow && this.container.dataset.slideshow == "true" ? true : false
        var gutter = parseInt(this.container.dataset.gutter)
        this.windowWidth = window.innerWidth;
        
        if (window.matchMedia('screen and (max-width: 768px)').matches && gutter > 0) {
          gutter = 15
        }

        var id = '.grid__item--' + sectionId
        this.packeryDefaults = {
          itemSelector: id,
          gutter: gutter
        }

        if (enableSlideshow) {
          this.flickityDefaults = { 
            contain: true, 
            adaptiveHeight: true,
            pageDots: true,
            autoPlay: false,
            prevNextButtons: true,
            pauseAutoPlayOnHover: true,
            watchCSS: true
          };
        }

        if (window.matchMedia('screen and (min-width: 769px)').matches || !enableSlideshow) {
          setTimeout(function() { this.initGrid() }.bind(this), 50);
        } else {
          this.initSlider()
        }

        if (enableSlideshow) {
          window.on('resize', theme.Helpers.debounce(300, function() {
            if (window.innerWidth != this.windowWidth) {this.windowWidth = window.innerWidth}else{return}
            this.resize(); 
          }.bind(this)));
        }

        /*window.addEventListener("orientationchange", function() { 
          console.log("orientationchanged")
          console.log(this.pckry)
          if(this.pckry){this.pckry.destroy()}   
          setTimeout(function() { this.initGrid() }.bind(this), 50);
        }.bind(this), false);*/


        window.on('orientationchange', theme.Helpers.debounce(300, function() {
          if(this.pckry){this.pckry.destroy()}   
          setTimeout(function() { this.initGrid() }.bind(this), 50);
        }.bind(this)), false);


        
        /*if (window.matchMedia('screen and (min-width: 769px)').matches || !enableSlideshow) {
          setTimeout(function() { this.initGrid() }.bind(this), 50);
        } else {
          this.initSlider()
        }

        window.on('resize', theme.Helpers.debounce(300, function() {
          if (enableSlideshow) {
            if (window.innerWidth != this.windowWidth) {this.windowWidth = window.innerWidth}else{return}
            this.resize(); 
          } else if ((window.matchMedia('screen and (max-width: 1050px)').matches && window.matchMedia('screen and (max-height: 500px)').matches) || (window.matchMedia('screen and (max-height: 1050px)').matches && window.matchMedia('screen and (max-width: 500px)').matches)) {
            if(this.pckry){this.pckry.destroy()}   
            setTimeout(function() { this.initGrid() }.bind(this), 50);
          }
        }.bind(this)));*/
      },

      initGrid: function() {
        this.pckry = new Packery(this.container, this.packeryDefaults);
      },
      
      initSlider: function() {
        this.flickity = new theme.Slideshow(this.container, this.flickityDefaults); 

        setInterval(function(){
          this.flickity.resize()
        }.bind(this),500);
      },

      resize: function() {
        if (window.matchMedia('screen and (min-width: 769px)').matches) {
          setTimeout(function() { this.initGrid() }.bind(this), 50);
        } else {
          this.pckry.destroy()
          this.initSlider()
        }
      }
    });
  
    return Promotion
  })();

  theme.isSessionStorageSupported = function() {
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage = window.sessionStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };
   
  theme.config.hasSessionStorage = theme.isSessionStorageSupported();
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  if (theme.config.hasLocalStorage) {
    var recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof(recentIds) !== undefined) {
      theme.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function(mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  theme.sizeDrawer = function() {
    var header = document.getElementById('HeaderWrapper').offsetHeight;
    var max = window.innerHeight - header;
    document.documentElement.style.setProperty('--maxDrawerHeight', `${max}px`);
  }
  
  /**
   * Things that require DOM to be ready
   */
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  theme.initGlobals = function() {
    theme.collapsibles.init();
  }

  DOMready(function(){
    theme.sections = new theme.Sections();
    
    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('tab-switcher', theme.TabSwitcher);
    theme.sections.register('background-image', theme.BackgroundImage);
    theme.sections.register('splittedtexts', theme.Splittedtexts);
    theme.sections.register('promotion', theme.Promotion);
    
    theme.initGlobals();
    slate.rte();
    theme.articleImages();

    
    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    theme.pageTransitions();

    document.dispatchEvent(new CustomEvent('page:loaded'));
    
  });
})();